import { twMerge } from "tailwind-merge";
import { ReactComponent as RadioChecked } from "../assets/icons/radio-checked.svg";
import { ReactComponent as Radio } from "../assets/icons/radio.svg";

export function RadioButton({
  checked,
  onChange,
  label,
  id,
  className = "",
}: {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  id: string;
  className?: string;
}) {
  return (
    <div className={twMerge("flex items-center gap-2 cursor-pointer", className)} onClick={() => onChange({ target: { value: id } } as React.ChangeEvent<HTMLInputElement>)}>
      {checked ? <RadioChecked className="w-4 h-4 relative [&>path]:stroke-[#134E4A]" /> : <Radio className="w-4 h-4 relative [&>path]:stroke-[#CBCBCB]" />}
      <label htmlFor={id} className="text-text-primary text-sm md:text-base font-normal cursor-pointer">{label}</label>
    </div>
  );
}